module.exports = ".container {\n    font-size: 1rem;\n}"